import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Toast,
  Checkbox,
  InlineError,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";

export const AddWorkflow = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const handleChangeName = (newValue) => {
    setNameValue(newValue);
    setNameError("");
  };
  const [descriptionValue, setDescriptionValue] = useState("");
  const handleChangeDescription = (newValue) => {
    setDescriptionValue(newValue);
  };
  const [nameError, setNameError] = useState("");
  const [selectedTrigger, setSelectedTrigger] = useState("");
  const handleSelectChangeTrigger = (newValue) => {
    setSelectedTrigger(newValue);
    setTriggerError("");
  };
  const optionsTrigger = [
    { label: "Contact us", value: "1" },
    { label: "Subscribe", value: "2" },
  ];
  const [triggerError, setTriggerError] = useState("");

  const [selectedAction, setSelectedAction] = useState("");
  const handleSelectChangeAction = (newValue) => {
    setSelectedAction(newValue);
    setActionError("");
  };

  const optionsAction = [
    { label: "Send Email to contact", value: "1" },
    { label: "Send Email internally", value: "2" },
  ];
  const [actionError, setActionError] = useState("");
  const [recipients, setRecipients] = useState([]);
  const handleChangeRecipients = (recipients) => {
    setRecipients(recipients);
    setRecipientsError("");
  };
  const [recipientsError, setRecipientsError] = useState("");
  const [active, setActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [checkedIsActive, setCheckedIsActive] = useState(true);
  const handleChangeIsActive = useCallback(
    (newChecked) => setCheckedIsActive(newChecked),
    []
  );

  return (
    <Page
      title="Add Workflow"
      narrowWidth
      backAction={{ onAction: () => navigate(`/admin/crm/automation`) }}
    >
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Name"
              value={nameValue}
              onChange={handleChangeName}
              error={nameError}
            />
            <TextField
              label="Description"
              value={descriptionValue}
              onChange={handleChangeDescription}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Trigger"
              options={optionsTrigger}
              onChange={handleSelectChangeTrigger}
              value={selectedTrigger}
              error={triggerError}
              placeholder="Please select"
            />
            <Select
              label="Action"
              options={optionsAction}
              onChange={handleSelectChangeAction}
              value={selectedAction}
              error={actionError}
              placeholder="Please select"
            />
          </FormLayout.Group>
          {selectedAction === "2" && (
            <div>
              <Text as="p" fontWeight="regular">
                Recipients
              </Text>
              <TagsInput
                value={recipients}
                onChange={handleChangeRecipients}
                inputProps={{
                  placeholder:
                    "Enter recipient email here and use the Enter key to add multiple emails",
                }}
              />
              <InlineError message={recipientsError} />
            </div>
          )}

          <Checkbox
            label="Is Active"
            checked={checkedIsActive}
            onChange={handleChangeIsActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !nameValue ||
      selectedTrigger === "" ||
      selectedAction === "" ||
      (selectedAction === "2" && recipients.length === 0)
    ) {
      !nameValue && setNameError("This field is required");
      selectedTrigger === "" && setTriggerError("This field is required");
      selectedAction === "" && setActionError("This field is required");
      selectedAction === "2" &&
        recipients.length === 0 &&
        setRecipientsError("Please add recipients emails");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: nameValue,
        description: descriptionValue,
        trigger: selectedTrigger,
        action: selectedAction,
        is_active: checkedIsActive ? 1 : 0,
        recipients: recipients,
      };
      axios
        .post("/crm/workflows", bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/automation");
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActive();
            setIsSaving(false);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js

            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};
